import { Globe, Check, ChevronDown } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { LANGS, useLang } from "@/lib/i18n";

export const LanguageSwitcher = ({ light = false, id = "header" }) => {
  const { lang, setLang } = useLang();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid={`${id}-lang-switcher`}
        className={`flex items-center gap-1.5 rounded-full border px-3 py-2 text-sm font-semibold uppercase transition-colors ${light ? "border-white/20 text-white hover:bg-white/10" : "border-white/10 text-white hover:bg-white/5"}`}
      >
        <Globe className="h-4 w-4" /> {lang} <ChevronDown className="h-3.5 w-3.5 opacity-60" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[160px]">
        {LANGS.map((l) => (
          <DropdownMenuItem key={l.code} data-testid={`${id}-lang-option-${l.code}`} onClick={() => setLang(l.code)} className="flex justify-between cursor-pointer">
            <span><span className="mr-2 font-bold uppercase text-slate-400">{l.code}</span>{l.label}</span>
            {lang === l.code && <Check className="h-4 w-4 text-[#2F7BFF]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
